import React, { useState } from 'react';

import { CodeIcon } from '@heroicons/react/outline';

export const ClearbitLogo = ({ host, classes }: { host: string; classes?: any }) => {
  const [hasError, setHasError] = useState(false);

  if (!hasError) {
    return (
      <img
        className={classes}
        src={`https://logo.clearbit.com/${host}`}
        onError={() => setHasError(true)}
        alt='Content Type Logo'
      />
    );
  }

  return <CodeIcon className={classes} />;
};
